var render = function (_h,_vm) {var _c=_vm._c;return _c('span',{staticClass:"flat-property"},[_vm._v(" "+_vm._s(_vm.props.property)+" "),_c('b',{domProps:{"innerHTML":_vm._s(_vm.props.value)}})])}
var staticRenderFns = []

export { render, staticRenderFns }